// src/App.tsx
import { useEffect, useState } from 'react';
import styles from './App.module.css';
import ResourceDisplay from './components/ResourceDisplay';
import AdminPanel from './components/AdminPanel';

function App() {
  const [isAdminPath, setIsAdminPath] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;
    setIsAdminPath(path === '/nicky' || path.startsWith('/nicky/'));
  }, []);

  if (isAdminPath) {
    return <AdminPanel />;
  }

  return (
    <div className={styles.App}>
      <div className={styles.AppHeader}>
        <ResourceDisplay folderName="latest" />
      </div>
      <footer className={styles.footer}>
        ©wokingcarboot {new Date().getFullYear()}
      </footer>
    </div>
  );
}

export default App;
